import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./ParishReport.module.css";
import plus from "../../../Assets/plus.svg"

import DeleteIcon from "../../../Assets/new-delete.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table, OverlayTrigger, Tooltip, } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import ToggleSlider from "./ToggleSlider";

const ParishReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [fullParishes, setFullParishes] = useState([]);
  const [perPage, setPerPage] = useState(100);



  const handleClose1 = () => { 
    setShow1(false) 
    setSelectedZone1("");
  };

  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData8, setTableData8] = useState([]);
  const [tableData6, setTableData6] = useState([]);
  const [tableData7, setTableData7] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);

  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedZone1, setSelectedZone1] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedArea1, setSelectedArea1] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [processLoading1, setProcessLoading1] = useState(false);
  const [description1, setDescription1] = useState('')
  const [selectedParish, setSelectedParish] = useState('');
  const [selectedParish1, setSelectedParish1] = useState('');
  const [eyeClicked, setEyeClicked] = useState(false);
  // const [fetchMode, setFetchMode] = useState('default'); 
  const [churchAddress, setChurchAddress] = useState("");
  const [description, setDescription] = useState('');


  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  // Pagination handlers
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  
  const handlePageClick = (page) => {
    setCurrentPage(page);
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);
  
      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
  
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }
  
    return pages;
  };
  

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const fetchSubProvinces = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/get_zones_by_name`,         
          {
                            params: {
                            page: currentPage,
                            // region_id: regionName,
                            province_id: provinceName,
                            // continent_id: continentName
                            },
                            headers: {
                              'Authorization': `Bearer ${TOKEN}`,
                              'Content-Type': 'application/json',
                            },
                          });

      // console.log(response);
      const subProv = response.data?.data;
      setTableData6(subProv); 
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData6([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubZones = async (selectedZone) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/get_areas_by_name`, 
         {
                    params: {
                    page: currentPage,
                    // region_id: regionName,
                    province_id: provinceName,
                    // continent_id: continentName
                    },
                    headers: {
                      'Authorization': `Bearer ${TOKEN}`,
                      'Content-Type': 'application/json',
                    },
                  });

      // console.log(response);
      const subZone = response.data?.data;
      setTableData7(subZone);
      // console.log(subCont, "heeeer");
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData7([]);
    } finally {
      setIsLoading(false);
    }
  };


    useEffect(() => {
      if (
        TOKEN  && provinceName) {
        fetchSubZones();
        fetchSubProvinces();
      }
    }, [TOKEN, currentPage, provinceName]);



 



  // Auto-fetch users when filters change

  // Fetch user types for dropdown
  // const fetchData1 = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL1}/provinces/getaparishprovince`,
  //        {
  //       headers: {
  //         'Authorization': `Bearer ${TOKEN}`,
  //         'Content-Type': 'application/json',
  //       },
  //     }
  //   );
  //     const parishesData = response.data?.data || [];
  //     setFullParishes(parishesData);
  //     setTotalEntries(parishesData.length);
  //     setTotalPages(Math.ceil(parishesData.length / perPage) || 1);
  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       // navigate('/login');
  //     } else {
  //       console.error("Error fetching user types:", error);
  //       setUserType([]);
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


   const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/provinces/get-parishes-by-name`, 
        {
        params: {
        page: currentPage,
        // region_id: regionName,
        province_id: provinceName,
        // continent_id: continentName
        },
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json',
        },
      });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;

     const parishesData = response.data?.data?.data || [];
      setFullParishes(parishesData);
      setTotalEntries(parishesData.length);
      setTotalPages(Math.ceil(parishesData.length / perPage) || 1);
      // setTotalEntries(resultx);   
      // setOptions(results);
      // console.log(results, "Users");
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);  // Uncomments: Use API last_page for pagination
    } catch (error) {
      // error handling
    } finally {
      setIsLoading(false);
    }
  };
  
useEffect(() => {
  if (
    TOKEN  && provinceName) {
    fetchData1();
    // FetchParish();
  }
}, [TOKEN, currentPage, provinceName]);

const filteredData = tableData8.filter(item => {
  const term = searchTerm.toLowerCase();
  return (
    item.description?.toLowerCase().includes(term) ||
    formatDate(item.created_at)?.toLowerCase().includes(term) ||  // Use your formatDate helper
    formatDate(item.updated_at)?.toLowerCase().includes(term)
  );
});

  useEffect(() => {
    if (fullParishes.length > 0) {
      const start = (currentPage - 1) * perPage;
      const end = start + perPage;
      setTableData8(fullParishes.slice(start, end));
    }
  }, [fullParishes, currentPage, perPage]);

  const finalData =
  searchTerm && searchTerm.trim().length > 0
    ? filteredData
    : tableData8;




  

  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    // resetNewUserForm();
  };

  const handleShowCreateUserModal = () => {
    setShowCreateUserModal(true);
    setModalError("");
  };

  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            {/* <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td> */}
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };



  const [createLoading, setCreateLoading] = useState(false);

  const editContinent = async () => {
    setCreateLoading(true);
    try {
      // /parishes/update-by-type
      // /parishes/update_province_parish
      const response = await axios.post(
        `${BASE_URL1}/parishes/update-by-type`,  
        {
          // /parishes/update-by-type
          description: description1,
          zone_id: selectedZone,
          id: selectedParish1,

          // area_id : selectedArea,
          // description: description1,
          // continent_id: selectedContinent1,
          // province_id: selectedProvince1,
          // region_id: selectedRegion1,
          // id : selectedParish1,
          // zone_id: selectedZone
        },
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`, 
            'Content-Type': 'application/json',
          },
        }
      );
      fetchData1();
      // Fetch updated zones after successful creation
      // fetchAreas();
      handleClose1();
      
      // Show success toast with response message
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      console.log(response);
  
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      
      // Check and handle specific error message
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.log(errorMessage);
      }
    } finally {
      setCreateLoading(false);
    }
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

 
  const fetchAllZones = async (provinceID) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const zoneList = response.data?.data || [];
      const formatted = zoneList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setZones(formatted);
  
      // 🚀 After zones load, fetch areas for the first zone
      // if (formatted.length > 0) {
      //   fetchAllAreas(formatted[0].value);
      // }
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
          setZones([]);
        } finally {
      setProvLoading(false);
    }
  };

  useEffect(() => {
    if (bearer && provinceID) {
      fetchAllZones(provinceID);
    }
  }, [TOKEN, provinceID]);
  

  const fetchAllAreas = async () => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${selectedZone || selectedZone1}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };

  useEffect(() => {
    if (TOKEN && selectedZone) {
      fetchAllAreas(selectedZone);
    }
  }, [TOKEN, selectedZone]);

  const handleEyeClick = (item) => {
    const foundParish = tableData.find(item => item.id === item.id);
    setSelectedParish1(item.id);
    setDescription1(item.description || '');
    setSelectedZone1(foundParish?.zone?.id || '');
    setSelectedArea1(foundParish?.area?.id || '');
    setShow1(true);
    setEyeClicked(true);
  };
  

  

  const handleProcess = async () => {
    setProcessLoading(true);

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-type?continent_id=${continentID}&region_id=${regionID}&province_id=${provinceID}&page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        // params: {
        //   zone_id: zones.id || '',
        //   area_id: selectedArea || ''
        // }
      });

       const results = response.data?.data?.parishes?.data;
      setTableData(results);
      const resultx = response.data?.data?.parishes?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.parishes?.last_page || 1;
      setTotalPages(total);

      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Failed',
      //   text: errorMessage,
      // });
    } finally {
      setProcessLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN, continentID, regionID, provinceID) {
      handleProcess();
    }
  }, [TOKEN, continentID, regionID, provinceID]);


  //   setProcessLoading1(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-param?continent_name=${continentName}&region_name=${regionName}&province_name=${provinceName}`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${TOKEN}`
  //       },
  //       // params: {
  //       //   zone_id: zones.id || '',
  //       //   area_id: selectedArea || ''
  //       // }
  //     });

  //     const results = response.data?.data.data || [];

  //     // const formatted = results.map((item) => ({
  //     //   id: item.id,
  //     //   description: item.description,
  //     //   created_at: item.created_at,
  //     //   updated_at: item.updated_at,
  //     //   continent: item?.continent?.description || "",
  //     //   province: item?.province?.description || "",
  //     //   region: item?.region?.description || "",
  //     // }));
  
  //     setTableData1(results);
  //     setTotalEntries(results.length);
  //     setTotalPages(1);
  //     // setTotalEntries(formatted.length); // For display text if needed
  //     setTotalPages(1);
  //     // const resultx = response.data?.data?.parishes?.total;
  //     // setTotalEntries(resultx);
  //     // const total = response.data?.data?.parishes?.last_page || 1;
  //     // setTotalPages(total);

  //     // Swal.fire({
  //     //   icon: 'success',
  //     //   title: 'Successful',
  //     //   text: response.data.message,
  //     // });
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }

  //     // Swal.fire({
  //     //   icon: 'error',
  //     //   title: 'Failed',
  //     //   text: errorMessage,
  //     // });
  //   } finally {
  //     setProcessLoading1(false);
  //   }
  // };

      // UPDATED: UseEffect for default fetchAll (only when fetchMode is 'default')
      // useEffect(() => {
      //   if (TOKEN && continentName && regionName && provinceName && fetchMode === 'default') {
      //     fetchAll();
      //   }
      // }, [TOKEN, continentName, regionName, provinceName]);
      // REMOVED: useEffect for handleProcess (no longer auto-called)
      // NEW: useEffect to refetch when currentPage changes in 'area' mode
      // useEffect(() => {
      //   if (fetchMode === 'area') {
      //     handleAreaProcess();
      //   }
      // }, [fetchMode]);


   const handleAreaProcess = async () => {
    setLoading(true);
  

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-all?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          zone_id: selectedZone || '',
          area_id: selectedArea || ''
        }
      });

      const results = response.data?.data?.data;
      setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleZone = (selectedOption) => {
    setSelectedZone(selectedOption.value);
  };
  const handleArea = (selectedOption) => {
    setSelectedArea(selectedOption.value);
    // if (!selectedOption.value) {
    //   setFetchMode('default');
    //   fetchAll();
    // }
  };
  const handleZone1 = (selectedOption) => {
    setSelectedZone1(selectedOption.value);
  };
  const handleArea1 = (selectedOption) => {
    setSelectedArea1(selectedOption.value);
  };

  const createParishes = async () => {

    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL1}/parishes/create_by_province`,
        {
          description: description,
          province_name: provinceName,
          zone_id: selectedZone,
          area_id: selectedArea,
          // church_address: churchAddress
         
        },
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`, 
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response)
      fetchData1();
      // fetchParishes();
      handleCloseCreateUserModal();
      setSelectedContinent('');
      setSelectedRegion("");
      setSelectedProvince("");
      setSelectedZone("");
      setSelectedArea("");
      setDescription("");
      // return
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
            }
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: errorMessage,
            });

    } finally {
      setCreateLoading(false);
    }
  };


  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  // const datatoRender = useMemo(() => {
  //   return fetchMode === 'area' ? tableData : tableData1;
  // }, [fetchMode, tableData, tableData1]);

   const datatoRender = tableData;

   const handleTrashClick = async (id) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this parish. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });

    if (confirmResult.isConfirmed) {
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/delete_parish?id=${id}`,  {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Content-Type': 'application/json'
        }, 
     });
      // fetchAllAreas();
      fetchData1();
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      setViewLoading(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
                // toast.error(errorMessage);
                Swal.fire({
                  icon: 'error',
                  title: 'Failed',
                  text: errorMessage,
                });
                setViewLoading(false);
            }
    }
  } else {
     
    Swal.fire({
      icon: 'info',
      title: 'Cancelled',
      text: 'The deletion was cancelled.',
    });
  }
  };

    const handleZoneChange = (event) =>{
    setSelectedZone(event.target.value)
  }
  const handleParisChange = (event) =>{
    setSelectedZone(event.target.value)
  }
  const handleAreaChange = (event) =>{
    setSelectedArea(event.target.value)
  }

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} 
      // size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Parish</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {/* {modalError && <Alert variant="danger">{modalError}</Alert>} */}

         <Form 
        //  style={{ marginTop: 20 }}
         >
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          
                         
                            <div style={{  }} />
                            <Form.Label>Zone</Form.Label>
                            <Form.Select  
                              className="form-control"
                              value={selectedZone}
                              onChange={handleZoneChange}
                            >
                            <option value="">Select Zone</option>
                            {tableData6.map((item) =>(
                              <option value={item.id} key={item.id}>
                                {item.description}
                              </option>
                            ))}
                            </Form.Select>
                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Area</Form.Label>
                            <Form.Select
                              className="form-control"
                              value={selectedArea}
                              onChange={handleAreaChange}
                            >
                              <option value="">Select Area</option>
                            {tableData7.map((item) =>(
                              <option value={item.id} key={item.id}>
                                {item.description}
                              </option>
                            ))}
                              </Form.Select>
                            
                            <div style={{ marginTop: 10 }} />
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            {/* <div style={{ marginTop: 10 }} />
                            <Form.Label>Church Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Address"
                              
                              value={churchAddress}
                              onChange={(e) => setChurchAddress(e.target.value)}
                            /> */}
                          </Form.Group>
                        </Form>

          {/* Rest of your modal content (permissions, roles, etc.) */}
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={ createParishes}

            variant="primary"
          >
            {/* {createLoading ? <><Spinner size="sm" /> Creating...</> : "Save User & Permissions"} */}
            {createLoading ? (
                      <>
                      <Spinner  size='sm' /> 
                      <span style={{ marginLeft: '5px' }}>Creating Parish, Please wait...</span>
    </>
  ) : (
                "Create Parish"
                      )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Parish</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                        <Form style={{ marginTop: 20 }}>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Zone</Form.Label>
                          <Form.Select  
                              className="form-control"
                              value={selectedZone}
                              onChange={handleZoneChange}
                            >
                            <option value="">Select Zone</option>
                            {tableData6.map((item) =>(
                              <option value={item.id} key={item.id}>
                                {item.description}
                              </option>
                            ))}
                            </Form.Select>
                                        <Form.Label className="mt-4">Areas</Form.Label>
                                        <Form.Select
                              className="form-control"
                              value={selectedArea}
                              onChange={handleAreaChange}
                            >
                              <option value="">Select Area</option>
                            {tableData7.map((item) =>(
                              <option value={item.id} key={item.id}>
                                {item.description}
                              </option>
                            ))}
                              </Form.Select>
                            <Form.Label className="mt-4">Description</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Description"
                              // autoFocus
                              value={description1}
                              onChange={(e) => setDescription1(e.target.value)}
                            />
                            
                          </Form.Group>
                        </Form>
                      </Modal.Body>

                      
                      <Modal.Footer>
                                <Button variant="secondary"  onClick={handleClose1}>
                                  Cancel
                                </Button>
                                <Button variant="primary" 
                                   className={classes.createUserButton}
                                onClick={editContinent} >
                                  {createLoading ? ( <> <Spinner  size='sm' />
                                    <span style={{ marginLeft: '5px' }}>
                                      Editing Parish, Please wait...
                                    </span>
                                    </>) : ("Save Changes")}
                                </Button>
                               

                               
                            </Modal.Footer>
        
        
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={updateUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Updating...</> : "Update User & Permissions"}
          </Button>
        </Modal.Footer> */}
      </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>
        {/* <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div> */}

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Parish</h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete Parishes</p>

        <div className={classes.subContainer} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between', marginBottom: '-17px', marginTop: '30px' }}>
          <div>
              <button className={classes.loanBtn} 
              onClick={handleShowCreateUserModal}>
                <img src={plus} alt="plus" /> Add Parish
              </button>
            </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}>
            {/* Continent Filter */}
            {/* <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Zones</Form.Label>
              <Select
                  onChange={(selectedOption) => 
                  handleZone(selectedOption)}
                  options={zones}
                placeholder="Select Area"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}
            
            {/* <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Area</Form.Label>
              <Select
                  onChange={(selectedOption) => handleArea(selectedOption)}
                  options={areas}
                placeholder="Select Area"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}


            {/* <Button
                                style={{ borderRadius: 5, marginLeft: "10px", marginTop: "26px", background: "#092147",  }} onClick={() => {
                                  // setFetchMode('area');
                                  // setCurrentPage(1);
                                  handleAreaProcess();
                                }} >
                                {loading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button> */}

            {/* Region Filter */}
            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}
          </div>

          {/* <div className={classes.statCount} style={{ flexShrink: 0, margin: '0 auto', marginRight: '5%' }}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Users</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{users.length}</p>
              )}
            </div>
          </div> */}

          {/* <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0 }}> */}

            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search parish..."
              />
              <Search className={classes.searchIcon} size={16} />
              {searchLoading && (
                <div className={classes.searchSpinner}>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{
                      width: '16px',
                      height: '16px'
                    }}
                  />
                </div>
              )}
            </div>

            {/* Print View Button */}
            {/* <div>
              <button className={classes.loanBtn} onClick={handlePrintView}>
                <MdPrint size={18} style={{ marginRight: '2px' }} />
                Print
              </button>
            </div> */}

            {/* Add New User Button */}
          
          {/* </div> */}
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                  <th>Parish Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    {/* <th>Province</th> */}
                   {/* <th>Area</th>
                  <th>Zone</th> */}
                    <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <SkeletonLoader />
              ) : finalData.length > 0 ? (
                finalData.map((item, index) => (
                  <tr style={{fontSize: "12px"}} key={item.id || index}>
                    
                  <td>{(currentPage - 1) * perPage + index + 1}</td>
                                                <td>{item.description}</td>
                                                <td>{formatDate(item.created_at)}</td>
                                                <td>{formatDate(item.updated_at)}</td>
                                                {/* <td>{item.province?.description}</td>
                                        <td>{item.area?.description}</td>
                                        <td></td> */}
                                        <td style={{display: "flex", gap: "10px"}}>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip">Click to view Parish</Tooltip>}
                  >
                    <button 
                    style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                    onClick={() => handleEyeClick(item)} 
                    >
                    <img src={EyeIcon} />
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip">Click to delete parish's row</Tooltip>}
                  >
                    <button 
                    style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                    onClick={() => handleTrashClick(item.id)}
                    >

                    <img src={DeleteIcon} />
                    </button>
                  </OverlayTrigger>
                </td>   
                  </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No parish found matching "${searchTerm}"` : "No parish available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
          Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalEntries)} of {totalEntries} entries
          </p>
        </div>
      </div>
    </div>
  )
}

export default ParishReport;